import { useNavigate } from 'react-router-dom'

import { Avatar, Badge, Box, Stack, Typography } from '@mui/material'
import { Paper } from 'oneui'
import { EllipsisStyle, SummaryPaperStyle } from 'styles/theme/theme'
import { EVENT_KEYS } from 'utils/constants'
import { isCJK, isFamilyNameOrderFirst } from 'utils/i18n'

import { ProfileCardProps } from '..'
import { AutomationTagIds } from '../../../../../assets/test/test-automation-tag-id'
import IconAlert from '../../assets/images/alert.svg'
import IconMessage from '../../assets/images/message.svg'

const defaultPhotoUrl = '/assets/images/profile/default-profile.svg'

const ProfileCard = ({ profile }: { profile: ProfileCardProps }) => {
  const navigate = useNavigate()

  const handleDashboardProfile = () => {
    navigate('/dashboard/profile')
  }

  return (
    <Paper
      sx={{
        ...SummaryPaperStyle,
        height: { xs: 'auto', md: '400px' },
        minHeight: '320px',
        padding: { xs: '10px 30px', md: '10px 40px' },
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      tabIndex={0}
      onClick={handleDashboardProfile}
      onKeyDown={(event) => {
        if (event.key === EVENT_KEYS.SPACE || event.key === EVENT_KEYS.ENTER) {
          event.preventDefault()
          handleDashboardProfile()
        }
      }}
      data-testid='PaperAF0BD2AF'
    >
      <Stack justifyContent='center' alignItems='center' sx={{ height: '100%', textAlign: 'center', width: '100%' }}>
        <Box
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', hegith: '100%' }}
          data-testid={AutomationTagIds['cards.dashboard-profile-icon']}
        >
          {profile.isShowBadge ? (
            <Badge
              overlap='circular'
              badgeContent={<Box component='img' src={IconAlert} alt='' />}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <Avatar sx={{ height: '66px', width: '66px' }} src={profile.photoUrl || defaultPhotoUrl} />
            </Badge>
          ) : (
            <Avatar sx={{ height: '66px', width: '66px' }} src={profile.photoUrl || defaultPhotoUrl} />
          )}
        </Box>
        <Box sx={{ margin: '20px 0', ...EllipsisStyle }} data-testid={AutomationTagIds['cards.dashboard-profile-data']}>
          <Typography
            sx={{
              fontSize: { xs: '25px', md: '30px' },
              lineHeight: { xs: '30px', md: '36px' },
              pb: { xs: '0', md: '4px' }
            }}
          >
            {isCJK(profile.givenName + profile.familyName)
              ? `${profile.familyName}${profile.givenName}`
              : isFamilyNameOrderFirst()
              ? `${profile.familyName} ${profile.givenName}`
              : `${profile.givenName} ${profile.familyName}`}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '15px' }
            }}
          >
            {profile.loginId}
          </Typography>
        </Box>
        {profile.statusMessage && (
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center' }}>
            <Box sx={{ width: '100%' }}>
              <Box component='img' src={IconMessage} alt='' />
            </Box>
            <Box sx={{ width: '100%' }}>
              <Typography variant='label1' sx={{ overflowWrap: 'break-word' }}>
                {profile.statusMessage}
              </Typography>
            </Box>
          </Box>
        )}
      </Stack>
    </Paper>
  )
}

export default ProfileCard
